module.exports = __webpack_public_path__ + "img/filter-type-mobility.289c2cbe.svg";